import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbCalendar } from "@ng-bootstrap/ng-bootstrap";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { AlertsService } from "src/app/shared/services/alerts.service";
import { DatePipe } from "@angular/common";
import { ConfirmeValidators } from "../../../../shared/directives/validators/confirme-validators";

@Component({
  selector: "app-modal-asignar-sancion",
  templateUrl: "./modal-asignar-sancion.component.html",
  styleUrls: ["./modal-asignar-sancion.component.scss"],
})
export class ModalAsignarSancionComponent implements OnInit {
  @Input()
  extensiones = ["application/pdf"];
  modalGenerico: ModalGenericoModel;
  formAsignarSancion: FormGroup;
  infoSancion: any;
  asignar: boolean;
  file: File = null;
  fechaActual = {
    day: new Date().getDate() + 1,
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  };

  constructor(
    private datePipe: DatePipe,
    public formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    public calendar: NgbCalendar,
    private alertService: AlertsService
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    if (this.asignar) {
      this.formAsignarSancion = this.formBuilder.group({
        titulo: [null, [Validators.required, ConfirmeValidators.noWhitespace]],
        fecha_inicio_sancion: [null, Validators.required],
        fecha_fin_sancion: [null],
        motivo: [null, [Validators.required, ConfirmeValidators.noWhitespace]],
        archivo: [null, Validators.required],
      });
    } else {
      this.formAsignarSancion = this.formBuilder.group({
        motivo: [null, [Validators.required, ConfirmeValidators.noWhitespace]],
        archivo: [null, Validators.required],
      });
    }
  }

  sendForm(): void {
    if (this.activeModal) {
      if (this.asignar) {
        this.formAsignarSancion.controls["fecha_inicio_sancion"].setValue(
          this.datePipe.transform(
            this.formAsignarSancion.value.fecha_inicio_sancion,
            "yyyy-MM-dd"
          )
        );
        this.formAsignarSancion.controls["fecha_fin_sancion"].setValue(
          this.datePipe.transform(
            this.formAsignarSancion.value.fecha_fin_sancion,
            "yyyy-MM-dd"
          )
        );
      }
      this.activeModal.close({
        data: { ...this.formAsignarSancion.value },
        archivo: this.file,
      });
    }
  }

  cancel() {
    this.formAsignarSancion.controls["archivo"].setValue(null);
    this.file = null;
  }

  onFileInput(eventFile) {
    const tempo = eventFile.target.files as FileList;
    const file = tempo.item(0);

    if (tempo.item.length > 0) {
      if (this.extensiones.indexOf(file.type) < 0) {
        this.alertService.warn(
          "Solo se permite archivos con extensión .pdf",
          "",
          "sin-codigo"
        );
        this.cancel();
        return false;
      } else if (file.size / 1024 / 1024 > 15) {
        this.alertService.warn(
          "Ha superado el tamaño máximo permitido (15Mb)",
          "",
          "sin-codigo"
        );
        this.cancel();
        return false;
      } else {
        this.file = tempo.item(0);
        this.formAsignarSancion.value.archivo = tempo.item(0);
      }
    }
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }
}
